// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../../../node_modules/rescript/lib/es6/array.js";
import * as Timestamp$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.mjs";
import * as DeccoUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.mjs";
import * as OrderType$PorterinFeature from "../entity/OrderType.mjs";
import * as OrderStatus$PorterinFeature from "../entity/OrderStatus.mjs";
import * as ValueAddedServices$PorterinFeature from "../entity/ValueAddedServices.mjs";
import * as OrderHistoryApiModel$PorterinFeature from "../api-model/OrderHistoryApiModel.mjs";

function getServiceDetails(service_details) {
  if (service_details !== undefined) {
    return {
            vehicle_id: service_details.vehicle_id,
            name: service_details.name,
            icon_url: service_details.icon_url
          };
  }
  
}

function getVasType(vas_type) {
  if (vas_type !== undefined) {
    return ValueAddedServices$PorterinFeature.fromString(vas_type);
  }
  
}

function getLocation(location_details) {
  return {
          lat: location_details.lat,
          long: location_details.long
        };
}

function getPlace(place) {
  var address = place.saved_address;
  return {
          doorstep_address: place.doorstep_address,
          saved_address: address !== undefined ? address.name : undefined,
          address: place.address
        };
}

function getContact(contact) {
  if (contact !== undefined) {
    return {
            name: contact.name,
            mobile: contact.number
          };
  }
  
}

function getAddressDetails(address_details) {
  if (address_details !== undefined) {
    return {
            location: getLocation(address_details.location),
            place: getPlace(address_details.place),
            contact: getContact(address_details.contact)
          };
  }
  
}

function getRouteDetails(order) {
  return {
          source: getAddressDetails(order.route_details.source),
          destination: getAddressDetails(order.route_details.destination),
          waypoint_info: {
            count: order.route_details.waypoint_info.count
          }
        };
}

function getTotalAmt(totalAmt) {
  if (totalAmt !== undefined) {
    return {
            currency: totalAmt.currency,
            amount: totalAmt.amount,
            cash_payable: totalAmt.cash_payable
          };
  }
  
}

function getOrderDetails(order_details) {
  return $$Array.map((function (order) {
                return {
                        order_crn: order.order_crn,
                        order_status: OrderStatus$PorterinFeature.fromString(order.order_status),
                        order_created_at: Timestamp$Catalyst.make(order.order_created_at),
                        _type: OrderType$PorterinFeature.fromString(order._type),
                        service_details: getServiceDetails(order.service_details),
                        vas_type: getVasType(order.vas_type),
                        is_business_customer: order.is_business_customer,
                        route_details: getRouteDetails(order),
                        total_amount: getTotalAmt(order.total_amount),
                        payment_mode: order.payment_mode,
                        pay_online_enabled: order.pay_online_enabled,
                        rebooking_enabled: order.rebooking_enabled,
                        muneemji_enabled: order.muneemji_enabled
                      };
              }), order_details);
}

function apiModelToEntity(res) {
  return {
          limit: res.limit,
          offset: res.offset,
          live_orders: getOrderDetails(res.live_orders),
          past_orders: getOrderDetails(res.past_orders)
        };
}

function execute(json) {
  return apiModelToEntity(DeccoUtils$Catalyst.resolveResult(OrderHistoryApiModel$PorterinFeature.t_decode(json), "OrderHistoryEntityMapper.res"));
}

export {
  getServiceDetails ,
  getVasType ,
  getLocation ,
  getPlace ,
  getContact ,
  getAddressDetails ,
  getRouteDetails ,
  getTotalAmt ,
  getOrderDetails ,
  apiModelToEntity ,
  execute ,
}
/* Timestamp-Catalyst Not a pure module */
